import { render } from "./SessionRecoveryDialog.vue?vue&type=template&id=35433a50&scoped=true"
import script from "./SessionRecoveryDialog.vue?vue&type=script&lang=js"
export * from "./SessionRecoveryDialog.vue?vue&type=script&lang=js"

import "./SessionRecoveryDialog.vue?vue&type=style&index=0&id=35433a50&scoped=true&lang=css"
import "./SessionRecoveryDialog.vue?vue&type=style&index=1&id=35433a50&lang=css"

import exportComponent from "../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35433a50"]])

export default __exports__